<div class="card">
  <div class="card-title text-center mt-3">
    <h3> CoronaVirus Updates for {{idData.country}} </h3>
  </div>
  <div class="row">
    <div class="col-sm-6">
      <div class = 'chart-custom'>
        <canvas id="mychart" ></canvas>
      </div>
    </div>
    <div class="col-sm-6 mt-5">
        <div class="containter custom-padding">
          <div class="row">
            <div class="col-sm-6">Confirmed</div>
            <div class = 'col-sm-6'>{{idData.cases}} </div>
          </div>
          <div class="row">
            <div class="col-sm-6">Active</div>
            <div class = 'col-sm-6'>{{idData.active}} </div>
          </div>

          <div class="row">
            <div class="col-sm-6">Recovered</div>
            <div class = 'col-sm-6'>{{idData.recovered}} </div>
          </div>
          <div class="row">
            <div class="col-sm-6">Deaths</div>
            <div class = 'col-sm-6'>{{idData.deaths}} </div>
          </div>
        </div>

    </div>
  </div>
  <div class="card-text">
  </div>
</div>
<!-- {{districtData | json}} -->
<!-- {{idData | json}} -->
<!-- {{idData.active | json}} -->
